module.exports = __webpack_public_path__ + "assets/img/kornati-carbon.465ce067.png";